var ComponentCategory = /* @__PURE__ */ ((ComponentCategory2) => {
  ComponentCategory2[ComponentCategory2["NONE"] = 0] = "NONE";
  ComponentCategory2[ComponentCategory2["AUGMENT"] = 1] = "AUGMENT";
  ComponentCategory2[ComponentCategory2["BEHAVIOR"] = 2] = "BEHAVIOR";
  ComponentCategory2[ComponentCategory2["COLLIDEFILTER"] = 3] = "COLLIDEFILTER";
  ComponentCategory2[ComponentCategory2["CONTAINER"] = 4] = "CONTAINER";
  ComponentCategory2[ComponentCategory2["EFFECT"] = 5] = "EFFECT";
  ComponentCategory2[ComponentCategory2["ENEMY"] = 6] = "ENEMY";
  ComponentCategory2[ComponentCategory2["INTERACTION"] = 7] = "INTERACTION";
  ComponentCategory2[ComponentCategory2["TRIGGER"] = 8] = "TRIGGER";
  ComponentCategory2[ComponentCategory2["MENU"] = 9] = "MENU";
  ComponentCategory2[ComponentCategory2["PHYSICS"] = 10] = "PHYSICS";
  ComponentCategory2[ComponentCategory2["RENDERING"] = 11] = "RENDERING";
  ComponentCategory2[ComponentCategory2["UI"] = 12] = "UI";
  ComponentCategory2[ComponentCategory2["WEAPON"] = 13] = "WEAPON";
  ComponentCategory2[ComponentCategory2["SPEEDMOD"] = 14] = "SPEEDMOD";
  ComponentCategory2[ComponentCategory2["GEM"] = 15] = "GEM";
  ComponentCategory2[ComponentCategory2["TYPE"] = 16] = "TYPE";
  ComponentCategory2[ComponentCategory2["PICKUP"] = 17] = "PICKUP";
  ComponentCategory2[ComponentCategory2["ON_PICKUP"] = 18] = "ON_PICKUP";
  ComponentCategory2[ComponentCategory2["ON_ADD_TO_INVENTORY"] = 19] = "ON_ADD_TO_INVENTORY";
  ComponentCategory2[ComponentCategory2["ONE_OFF"] = 20] = "ONE_OFF";
  ComponentCategory2[ComponentCategory2["ON_ADD_TO_PARENT"] = 21] = "ON_ADD_TO_PARENT";
  ComponentCategory2[ComponentCategory2["ON_REMOVE_FROM_PARENT"] = 22] = "ON_REMOVE_FROM_PARENT";
  ComponentCategory2[ComponentCategory2["CORE"] = 23] = "CORE";
  ComponentCategory2[ComponentCategory2["MAP"] = 24] = "MAP";
  ComponentCategory2[ComponentCategory2["PERSIST"] = 25] = "PERSIST";
  ComponentCategory2[ComponentCategory2["DAMAGE"] = 26] = "DAMAGE";
  ComponentCategory2[ComponentCategory2["DAMAGEMOD"] = 27] = "DAMAGEMOD";
  ComponentCategory2[ComponentCategory2["ONDAMAGE"] = 28] = "ONDAMAGE";
  ComponentCategory2[ComponentCategory2["ON_APPLY_DAMAGE"] = 29] = "ON_APPLY_DAMAGE";
  ComponentCategory2[ComponentCategory2["PROJECTILECOUNTMOD"] = 30] = "PROJECTILECOUNTMOD";
  ComponentCategory2[ComponentCategory2["WEAPON_AUGMENT"] = 31] = "WEAPON_AUGMENT";
  ComponentCategory2[ComponentCategory2["ONITEMDROP_MOD"] = 32] = "ONITEMDROP_MOD";
  ComponentCategory2[ComponentCategory2["DAMAGEAPPLIER"] = 33] = "DAMAGEAPPLIER";
  ComponentCategory2[ComponentCategory2["ONHIT"] = 34] = "ONHIT";
  ComponentCategory2[ComponentCategory2["ONHIT_MOD"] = 35] = "ONHIT_MOD";
  ComponentCategory2[ComponentCategory2["DAMAGEINTERACTION"] = 36] = "DAMAGEINTERACTION";
  ComponentCategory2[ComponentCategory2["TARGET"] = 37] = "TARGET";
  ComponentCategory2[ComponentCategory2["AURA"] = 38] = "AURA";
  ComponentCategory2[ComponentCategory2["ON_ENTITY_CREATION"] = 39] = "ON_ENTITY_CREATION";
  ComponentCategory2[ComponentCategory2["ONKILL"] = 40] = "ONKILL";
  ComponentCategory2[ComponentCategory2["ONDEATH"] = 41] = "ONDEATH";
  ComponentCategory2[ComponentCategory2["ONDODGE"] = 42] = "ONDODGE";
  ComponentCategory2[ComponentCategory2["ONHEAL"] = 43] = "ONHEAL";
  ComponentCategory2[ComponentCategory2["ONLEVELUP"] = 44] = "ONLEVELUP";
  ComponentCategory2[ComponentCategory2["ON_START"] = 45] = "ON_START";
  ComponentCategory2[ComponentCategory2["ON_END"] = 46] = "ON_END";
  return ComponentCategory2;
})(ComponentCategory || {});
var SoundType = /* @__PURE__ */ ((SoundType2) => {
  SoundType2[SoundType2["DEFAULT"] = 0] = "DEFAULT";
  SoundType2[SoundType2["FX"] = 1] = "FX";
  SoundType2[SoundType2["MUSIC"] = 2] = "MUSIC";
  SoundType2[SoundType2["UI"] = 3] = "UI";
  SoundType2[SoundType2["VOICE"] = 4] = "VOICE";
  SoundType2[SoundType2["AMBIENT"] = 5] = "AMBIENT";
  return SoundType2;
})(SoundType || {});
var EntityType = /* @__PURE__ */ ((EntityType2) => {
  EntityType2[EntityType2["ENTITY"] = 0] = "ENTITY";
  EntityType2[EntityType2["ENEMY"] = 1] = "ENEMY";
  EntityType2[EntityType2["ALTAR"] = 2] = "ALTAR";
  EntityType2[EntityType2["PROJECTILE"] = 3] = "PROJECTILE";
  EntityType2[EntityType2["PICKUP"] = 4] = "PICKUP";
  EntityType2[EntityType2["ALLY"] = 5] = "ALLY";
  EntityType2[EntityType2["WEAPON"] = 6] = "WEAPON";
  EntityType2[EntityType2["WALL"] = 7] = "WALL";
  EntityType2[EntityType2["INTERACTABLE"] = 8] = "INTERACTABLE";
  EntityType2[EntityType2["MAP"] = 9] = "MAP";
  EntityType2[EntityType2["DOOR"] = 10] = "DOOR";
  EntityType2[EntityType2["PLAYER"] = 11] = "PLAYER";
  return EntityType2;
})(EntityType || {});
var WeaponTypeEnum = /* @__PURE__ */ ((WeaponTypeEnum2) => {
  WeaponTypeEnum2[WeaponTypeEnum2["NONE"] = 0] = "NONE";
  WeaponTypeEnum2[WeaponTypeEnum2["SWORD"] = 1] = "SWORD";
  WeaponTypeEnum2[WeaponTypeEnum2["BOW"] = 2] = "BOW";
  WeaponTypeEnum2[WeaponTypeEnum2["GUN"] = 3] = "GUN";
  WeaponTypeEnum2[WeaponTypeEnum2["STAFF"] = 4] = "STAFF";
  WeaponTypeEnum2[WeaponTypeEnum2["MAGIC"] = 5] = "MAGIC";
  return WeaponTypeEnum2;
})(WeaponTypeEnum || {});
var EnemyTypeEnum = /* @__PURE__ */ ((EnemyTypeEnum2) => {
  EnemyTypeEnum2[EnemyTypeEnum2["U_DEF"] = 0] = "U_DEF";
  EnemyTypeEnum2[EnemyTypeEnum2["ALL"] = 1] = "ALL";
  EnemyTypeEnum2[EnemyTypeEnum2["DEMON"] = 2] = "DEMON";
  EnemyTypeEnum2[EnemyTypeEnum2["SLUDGE"] = 3] = "SLUDGE";
  EnemyTypeEnum2[EnemyTypeEnum2["NECROMANCER"] = 4] = "NECROMANCER";
  EnemyTypeEnum2[EnemyTypeEnum2["ORC"] = 5] = "ORC";
  EnemyTypeEnum2[EnemyTypeEnum2["ZOMBIE"] = 6] = "ZOMBIE";
  return EnemyTypeEnum2;
})(EnemyTypeEnum || {});
var TriggerTypeEnum = /* @__PURE__ */ ((TriggerTypeEnum2) => {
  TriggerTypeEnum2[TriggerTypeEnum2["DEATH"] = 0] = "DEATH";
  TriggerTypeEnum2[TriggerTypeEnum2["HEALTH_DECREASE"] = 1] = "HEALTH_DECREASE";
  TriggerTypeEnum2[TriggerTypeEnum2["HEALTH_INCREASE"] = 2] = "HEALTH_INCREASE";
  TriggerTypeEnum2[TriggerTypeEnum2["ONATTACH"] = 3] = "ONATTACH";
  TriggerTypeEnum2[TriggerTypeEnum2["TIME"] = 4] = "TIME";
  return TriggerTypeEnum2;
})(TriggerTypeEnum || {});
var WaveTypeEnum = /* @__PURE__ */ ((WaveTypeEnum2) => {
  WaveTypeEnum2[WaveTypeEnum2["SINE"] = 0] = "SINE";
  WaveTypeEnum2[WaveTypeEnum2["SQUARE"] = 1] = "SQUARE";
  WaveTypeEnum2[WaveTypeEnum2["TRIANGLE"] = 2] = "TRIANGLE";
  WaveTypeEnum2[WaveTypeEnum2["SAWTOOTH"] = 3] = "SAWTOOTH";
  return WaveTypeEnum2;
})(WaveTypeEnum || {});
var ReactStateEnum = /* @__PURE__ */ ((ReactStateEnum2) => {
  ReactStateEnum2[ReactStateEnum2["CHASING"] = 0] = "CHASING";
  ReactStateEnum2[ReactStateEnum2["IDLE"] = 1] = "IDLE";
  ReactStateEnum2[ReactStateEnum2["INITIAL"] = 2] = "INITIAL";
  return ReactStateEnum2;
})(ReactStateEnum || {});
var GemTypeEnum = /* @__PURE__ */ ((GemTypeEnum2) => {
  GemTypeEnum2[GemTypeEnum2["SUPPORT"] = 0] = "SUPPORT";
  GemTypeEnum2[GemTypeEnum2["DASH"] = 1] = "DASH";
  GemTypeEnum2[GemTypeEnum2["ABILITY"] = 2] = "ABILITY";
  GemTypeEnum2[GemTypeEnum2["ULTIMATE"] = 3] = "ULTIMATE";
  return GemTypeEnum2;
})(GemTypeEnum || {});
var AuraApplicatorTypeEnum = /* @__PURE__ */ ((AuraApplicatorTypeEnum2) => {
  AuraApplicatorTypeEnum2[AuraApplicatorTypeEnum2["ON_HIT"] = 0] = "ON_HIT";
  AuraApplicatorTypeEnum2[AuraApplicatorTypeEnum2["SELF"] = 1] = "SELF";
  return AuraApplicatorTypeEnum2;
})(AuraApplicatorTypeEnum || {});
var CollisionCategoryEnum = /* @__PURE__ */ ((CollisionCategoryEnum2) => {
  CollisionCategoryEnum2[CollisionCategoryEnum2["NONE"] = 0] = "NONE";
  CollisionCategoryEnum2[CollisionCategoryEnum2["DEFAULT"] = 1] = "DEFAULT";
  CollisionCategoryEnum2[CollisionCategoryEnum2["ALLY"] = 2] = "ALLY";
  CollisionCategoryEnum2[CollisionCategoryEnum2["ENEMY"] = 4] = "ENEMY";
  CollisionCategoryEnum2[CollisionCategoryEnum2["PROJECTILE"] = 8] = "PROJECTILE";
  CollisionCategoryEnum2[CollisionCategoryEnum2["PICKUP"] = 16] = "PICKUP";
  CollisionCategoryEnum2[CollisionCategoryEnum2["WALL"] = 32] = "WALL";
  CollisionCategoryEnum2[CollisionCategoryEnum2["INTERACTABLE"] = 64] = "INTERACTABLE";
  CollisionCategoryEnum2[CollisionCategoryEnum2["MAP"] = 128] = "MAP";
  CollisionCategoryEnum2[CollisionCategoryEnum2["TERRAIN"] = 256] = "TERRAIN";
  CollisionCategoryEnum2[CollisionCategoryEnum2["PLAYER"] = 512] = "PLAYER";
  CollisionCategoryEnum2[CollisionCategoryEnum2["ALL"] = 65535] = "ALL";
  return CollisionCategoryEnum2;
})(CollisionCategoryEnum || {});
var SeekPointSpeedTypeEnum = /* @__PURE__ */ ((SeekPointSpeedTypeEnum2) => {
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["LINEAR"] = 0] = "LINEAR";
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["SLOW"] = 1] = "SLOW";
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["SINE"] = 2] = "SINE";
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["SINE_SLOW"] = 3] = "SINE_SLOW";
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["SAWTOOTH"] = 4] = "SAWTOOTH";
  SeekPointSpeedTypeEnum2[SeekPointSpeedTypeEnum2["SAWTOOTH_SLOW"] = 5] = "SAWTOOTH_SLOW";
  return SeekPointSpeedTypeEnum2;
})(SeekPointSpeedTypeEnum || {});
var MobCircleSpawnStrategyEnum = /* @__PURE__ */ ((MobCircleSpawnStrategyEnum2) => {
  MobCircleSpawnStrategyEnum2[MobCircleSpawnStrategyEnum2["RANDOM"] = 0] = "RANDOM";
  MobCircleSpawnStrategyEnum2[MobCircleSpawnStrategyEnum2["UNIFORM"] = 1] = "UNIFORM";
  return MobCircleSpawnStrategyEnum2;
})(MobCircleSpawnStrategyEnum || {});
var MobSpawnPositionEnum = /* @__PURE__ */ ((MobSpawnPositionEnum2) => {
  MobSpawnPositionEnum2[MobSpawnPositionEnum2["CIRCLE"] = 0] = "CIRCLE";
  MobSpawnPositionEnum2[MobSpawnPositionEnum2["GROUPED"] = 1] = "GROUPED";
  MobSpawnPositionEnum2[MobSpawnPositionEnum2["RANDOM"] = 2] = "RANDOM";
  return MobSpawnPositionEnum2;
})(MobSpawnPositionEnum || {});
var OrbPatternEnum = /* @__PURE__ */ ((OrbPatternEnum2) => {
  OrbPatternEnum2[OrbPatternEnum2["NONE"] = 0] = "NONE";
  OrbPatternEnum2[OrbPatternEnum2["STROBE_ROTATE"] = 1] = "STROBE_ROTATE";
  return OrbPatternEnum2;
})(OrbPatternEnum || {});
var DamageDirectionEnum = /* @__PURE__ */ ((DamageDirectionEnum2) => {
  DamageDirectionEnum2[DamageDirectionEnum2["PROJECTILE"] = 0] = "PROJECTILE";
  DamageDirectionEnum2[DamageDirectionEnum2["OWNER"] = 1] = "OWNER";
  return DamageDirectionEnum2;
})(DamageDirectionEnum || {});
var DamageTypeEnum = /* @__PURE__ */ ((DamageTypeEnum2) => {
  DamageTypeEnum2[DamageTypeEnum2["NORMAL"] = 0] = "NORMAL";
  DamageTypeEnum2[DamageTypeEnum2["FIRE"] = 1] = "FIRE";
  DamageTypeEnum2[DamageTypeEnum2["ICE"] = 2] = "ICE";
  DamageTypeEnum2[DamageTypeEnum2["SHOCK"] = 3] = "SHOCK";
  DamageTypeEnum2[DamageTypeEnum2["CHAOS"] = 4] = "CHAOS";
  DamageTypeEnum2[DamageTypeEnum2["ALLY"] = 5] = "ALLY";
  return DamageTypeEnum2;
})(DamageTypeEnum || {});
var DamageCategoryEnum = /* @__PURE__ */ ((DamageCategoryEnum2) => {
  DamageCategoryEnum2[DamageCategoryEnum2["NONE"] = 0] = "NONE";
  DamageCategoryEnum2[DamageCategoryEnum2["MELEE"] = 1] = "MELEE";
  DamageCategoryEnum2[DamageCategoryEnum2["RANGED"] = 2] = "RANGED";
  DamageCategoryEnum2[DamageCategoryEnum2["ELEMENTAL"] = 3] = "ELEMENTAL";
  DamageCategoryEnum2[DamageCategoryEnum2["AOE"] = 4] = "AOE";
  DamageCategoryEnum2[DamageCategoryEnum2["ALL"] = 5] = "ALL";
  return DamageCategoryEnum2;
})(DamageCategoryEnum || {});
var FaceDirectionEnum = /* @__PURE__ */ ((FaceDirectionEnum2) => {
  FaceDirectionEnum2[FaceDirectionEnum2["NONE"] = 0] = "NONE";
  FaceDirectionEnum2[FaceDirectionEnum2["ROTATE"] = 1] = "ROTATE";
  FaceDirectionEnum2[FaceDirectionEnum2["HORIZONTAL"] = 2] = "HORIZONTAL";
  FaceDirectionEnum2[FaceDirectionEnum2["VERTICAL"] = 3] = "VERTICAL";
  FaceDirectionEnum2[FaceDirectionEnum2["HORIZONTAL_ROTATE"] = 4] = "HORIZONTAL_ROTATE";
  return FaceDirectionEnum2;
})(FaceDirectionEnum || {});
var PickupStateEnum = /* @__PURE__ */ ((PickupStateEnum2) => {
  PickupStateEnum2[PickupStateEnum2["PICKED_UP"] = 0] = "PICKED_UP";
  PickupStateEnum2[PickupStateEnum2["CARRIED"] = 1] = "CARRIED";
  PickupStateEnum2[PickupStateEnum2["DROPPED"] = 2] = "DROPPED";
  PickupStateEnum2[PickupStateEnum2["ON_THE_GROUND"] = 3] = "ON_THE_GROUND";
  PickupStateEnum2[PickupStateEnum2["STUCK"] = 4] = "STUCK";
  PickupStateEnum2[PickupStateEnum2["STATIC"] = 5] = "STATIC";
  PickupStateEnum2[PickupStateEnum2["INTERACTABLE"] = 6] = "INTERACTABLE";
  PickupStateEnum2[PickupStateEnum2["BROKEN"] = 7] = "BROKEN";
  return PickupStateEnum2;
})(PickupStateEnum || {});
var FlingComponentPositionTypeEnum = /* @__PURE__ */ ((FlingComponentPositionTypeEnum2) => {
  FlingComponentPositionTypeEnum2[FlingComponentPositionTypeEnum2["CIRCLE"] = 0] = "CIRCLE";
  FlingComponentPositionTypeEnum2[FlingComponentPositionTypeEnum2["POSITION"] = 1] = "POSITION";
  FlingComponentPositionTypeEnum2[FlingComponentPositionTypeEnum2["CIRCLE_POSITION"] = 2] = "CIRCLE_POSITION";
  return FlingComponentPositionTypeEnum2;
})(FlingComponentPositionTypeEnum || {});
var InheritFromParentEnum = /* @__PURE__ */ ((InheritFromParentEnum2) => {
  InheritFromParentEnum2[InheritFromParentEnum2["NONE"] = 0] = "NONE";
  InheritFromParentEnum2[InheritFromParentEnum2["OWNER"] = 1] = "OWNER";
  InheritFromParentEnum2[InheritFromParentEnum2["SOURCE"] = 2] = "SOURCE";
  InheritFromParentEnum2[InheritFromParentEnum2["WEAPON"] = 3] = "WEAPON";
  InheritFromParentEnum2[InheritFromParentEnum2["HIT_OWNER"] = 4] = "HIT_OWNER";
  InheritFromParentEnum2[InheritFromParentEnum2["HIT_SOURCE"] = 5] = "HIT_SOURCE";
  InheritFromParentEnum2[InheritFromParentEnum2["HIT_WEAPON"] = 6] = "HIT_WEAPON";
  InheritFromParentEnum2[InheritFromParentEnum2["HIT_VALUE"] = 7] = "HIT_VALUE";
  InheritFromParentEnum2[InheritFromParentEnum2["REVERSE_HIT_VALUE"] = 8] = "REVERSE_HIT_VALUE";
  return InheritFromParentEnum2;
})(InheritFromParentEnum || {});
var DialogTypeEnum = /* @__PURE__ */ ((DialogTypeEnum2) => {
  DialogTypeEnum2[DialogTypeEnum2["YARN"] = 0] = "YARN";
  DialogTypeEnum2[DialogTypeEnum2["TEXT"] = 1] = "TEXT";
  DialogTypeEnum2[DialogTypeEnum2["CHOICE"] = 2] = "CHOICE";
  DialogTypeEnum2[DialogTypeEnum2["CONFIRM"] = 3] = "CONFIRM";
  DialogTypeEnum2[DialogTypeEnum2["RESTART"] = 4] = "RESTART";
  return DialogTypeEnum2;
})(DialogTypeEnum || {});
var VisibleConditionEnum = /* @__PURE__ */ ((VisibleConditionEnum2) => {
  VisibleConditionEnum2[VisibleConditionEnum2["COMPONENT"] = 0] = "COMPONENT";
  return VisibleConditionEnum2;
})(VisibleConditionEnum || {});
var VisibleConditionTypeEnum = /* @__PURE__ */ ((VisibleConditionTypeEnum2) => {
  VisibleConditionTypeEnum2[VisibleConditionTypeEnum2["BOOLEAN"] = 0] = "BOOLEAN";
  VisibleConditionTypeEnum2[VisibleConditionTypeEnum2["NUMBER"] = 1] = "NUMBER";
  VisibleConditionTypeEnum2[VisibleConditionTypeEnum2["STRING"] = 2] = "STRING";
  return VisibleConditionTypeEnum2;
})(VisibleConditionTypeEnum || {});
var VisibleConditionOperatorEnum = /* @__PURE__ */ ((VisibleConditionOperatorEnum2) => {
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["EQUAL"] = 0] = "EQUAL";
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["NOT_EQUAL"] = 1] = "NOT_EQUAL";
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["GREATER_THAN"] = 2] = "GREATER_THAN";
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["LESS_THAN"] = 3] = "LESS_THAN";
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["GREATER_THAN_OR_EQUAL"] = 4] = "GREATER_THAN_OR_EQUAL";
  VisibleConditionOperatorEnum2[VisibleConditionOperatorEnum2["LESS_THAN_OR_EQUAL"] = 5] = "LESS_THAN_OR_EQUAL";
  return VisibleConditionOperatorEnum2;
})(VisibleConditionOperatorEnum || {});
var StabStateEnum = /* @__PURE__ */ ((StabStateEnum2) => {
  StabStateEnum2[StabStateEnum2["STAB"] = 0] = "STAB";
  StabStateEnum2[StabStateEnum2["RETURN"] = 1] = "RETURN";
  StabStateEnum2[StabStateEnum2["NONE"] = 2] = "NONE";
  return StabStateEnum2;
})(StabStateEnum || {});
var SwingStateEnum = /* @__PURE__ */ ((SwingStateEnum2) => {
  SwingStateEnum2[SwingStateEnum2["WINDUP"] = 0] = "WINDUP";
  SwingStateEnum2[SwingStateEnum2["SWING"] = 1] = "SWING";
  SwingStateEnum2[SwingStateEnum2["NONE"] = 2] = "NONE";
  return SwingStateEnum2;
})(SwingStateEnum || {});
const baseEnums = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuraApplicatorTypeEnum,
  CollisionCategoryEnum,
  ComponentCategory,
  DamageCategoryEnum,
  DamageDirectionEnum,
  DamageTypeEnum,
  DialogTypeEnum,
  EnemyTypeEnum,
  EntityType,
  FaceDirectionEnum,
  FlingComponentPositionTypeEnum,
  GemTypeEnum,
  InheritFromParentEnum,
  MobCircleSpawnStrategyEnum,
  MobSpawnPositionEnum,
  OrbPatternEnum,
  PickupStateEnum,
  ReactStateEnum,
  SeekPointSpeedTypeEnum,
  SoundType,
  StabStateEnum,
  SwingStateEnum,
  TriggerTypeEnum,
  VisibleConditionEnum,
  VisibleConditionOperatorEnum,
  VisibleConditionTypeEnum,
  WaveTypeEnum,
  WeaponTypeEnum
}, Symbol.toStringTag, { value: "Module" }));
export {
  AuraApplicatorTypeEnum as A,
  ComponentCategory as C,
  DamageDirectionEnum as D,
  EntityType as E,
  FaceDirectionEnum as F,
  GemTypeEnum as G,
  InheritFromParentEnum as I,
  MobCircleSpawnStrategyEnum as M,
  OrbPatternEnum as O,
  PickupStateEnum as P,
  ReactStateEnum as R,
  SoundType as S,
  TriggerTypeEnum as T,
  VisibleConditionOperatorEnum as V,
  WeaponTypeEnum as W,
  EnemyTypeEnum as a,
  baseEnums as b,
  WaveTypeEnum as c,
  CollisionCategoryEnum as d,
  VisibleConditionEnum as e,
  VisibleConditionTypeEnum as f,
  SeekPointSpeedTypeEnum as g,
  MobSpawnPositionEnum as h,
  DamageTypeEnum as i,
  DamageCategoryEnum as j,
  FlingComponentPositionTypeEnum as k,
  DialogTypeEnum as l,
  StabStateEnum as m,
  SwingStateEnum as n
};
//# sourceMappingURL=enums-86f58524.js.map
